export const iconFontAwesomeHumanitarianPersonCircleExclamation = (
	<i className="fa-solid fa-person-circle-exclamation"></i>
);
